const filterTradingPoints = (zoneP, cityP, tradingPoints, setTradingPointsState) => {
  const filtered = tradingPoints.filter(({ zone, city }) => {
    return (zoneP === null || zone?.value === zoneP) && (cityP === null || city.value === cityP);
  });

  setTradingPointsState(filtered);
};

const filterZones = (cityP, cities, setLocationDropdown) => {
  const city = cities.find(obj => obj.value === cityP);
  setLocationDropdown(city.zones);
};

const defaultMarker = (cityName, cities) => {
  const marker = cities.filter(({ value }) => {
    return cityName === value;
  });

  return marker[0];
};

export { filterTradingPoints, filterZones, defaultMarker };
